/* eslint-disable consistent-return */
import {
  Avatar,
  Button,
  Grid,
  Paper,
  Tooltip,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { FindInPage, Room } from '@material-ui/icons';
import MailIcon from '@material-ui/icons/Mail';
import PhoneIcon from '@material-ui/icons/Phone';
import {
  getInfosDashboard,
  getNumberFormationById,
} from '@webapps/business';
import {
  useQuery,
  useRouter,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import VerifiedIcon from 'components/Icons/VerifiedIcon';
import { ROUTES_PATH } from 'config/constants';
import { useEffect } from 'react';
import * as yup from 'yup';

const searchSchema = yup.object().shape({
  keyword: yup.string(),
});

const LightTooltip = withStyles(({ shadows }) => ({
  tooltip: {
    backgroundColor: '#5D75A8',
    color: '#FFF',
    boxShadow: shadows[1],
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
    '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontWeight: 600,
  },
}))(Tooltip);

const AddPartnerCard = ({
  account,
  address,
  id,
  name,
  handleOpenConfirmDialog,
}) => {
  const {
    css,
    classes,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const { push } = useRouter();
  const { addToast } = useToast();

  const viewPartner = (id) => {
    push(ROUTES_PATH.SCHOOL_VITRINE, { params: { id } });
  };

  const { data: nbr } = useQuery(getNumberFormationById, {
    key: ['nbrFormation', id],
    variables: { id },
  });

  const { data: infos } = useQuery(getInfosDashboard, {
    key: ['infos', id],
    variables: { id },
  });

  return (
    <Grid key={id} item xs={12} sm={12} md={4}>
      <Paper className={classes.cardContainer} elevation={0}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div className={cx(classes.avatarNameDiv, global.title)}>
            <Avatar
              className={classes.avatar}
              src={infos?.profile?.profileImageUrl}
            />
            <div className={classes.nameAdressDiv}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  columnGap: 5,
                }}
              >
                {name} <VerifiedIcon color={'#1DA1F2'} className={global.smallIcon} />
              </div>
              <div className={cx(global.frac, global.infoText)}>
                <Room className={global.infoIcon}/>{' '}
                {account?.address?.city || 'Adresse'}{' '}
                {account?.address?.cityCode}
              </div>
            </div>
          </div>
          <div
            className={css({
              display: 'flex',
              flexDirection: 'column',
              rowGap: 10,
              marginTop: 20,
              marginBottom: 20,
            })}
          >
            <div className={cx(global.frac ,global.infoText)}>
              <FindInPage className={global.infoIcon} />
              {nbr ? nbr : 0} Offres de formation disponible
            </div>
            <div className={cx(global.frac ,global.infoText)}>
              <MailIcon className={global.infoIcon} />
              Masquée jusqu'à acceptation du partenaire
            </div>
            <div className={cx(global.frac ,global.infoText)}>
              <PhoneIcon className={global.infoIcon} />
              Masquée jusqu'à acceptation du partenaire
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              rowGap: 10,
            }}
          >
            {account?.subscription?.toLowerCase() === 'premium' ? (
              <>
                <Button
                  onClick={() => handleOpenConfirmDialog(id)}
                  fullWidth
                  disableElevation
                  variant="contained"
                  color="primary"
                  className={
                    css({
                      borderRadius: 400,
                    })
                  }
                >
                  Demander un partenariat
                </Button>
              </>
            ) : (
              <LightTooltip
                title="Vous ne pouvez pas ajouter un partenaire ayant un compte gratuit 🔒"
                placement="top"
              >
                <span>
                  <Button
                    disabled
                    fullWidth
                    color="primary"
                    variant="contained"
                    className={
                      css({
                        borderRadius: 400,
                      })
                    }
                  >
                    Demander un partenariat
                  </Button>
                </span>
              </LightTooltip>
            )}
            <div>
              <Button
                onClick={() => viewPartner(id)}
                fullWidth
                variant="contained"
                disableElevation
                style={{
                  backgroundColor: '#F3F7FF',
                  outline: '1px solid #C0D9FF',
                  color: "#5A6DA1",
                  borderRadius: 10
                }}
              >
                Voir la vitrine
              </Button>
            </div>
          </div>
        </div>
      </Paper>
    </Grid>
  );
};

const styles = ({ spacing }) => ({
  cardContainer: {
    borderRadius: 10,
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: spacing(2),
    paddingRight: spacing(2),
    height: '100%',
    padding: 20,
  },
  PartenerCardContainer: {
    margin: 0,
    width: '100%',
    '@media screen and (max-width: 768px)': {
      flexDirection: 'column',
    },
  },
  nameAdressDiv: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 10,
  },
  avatarNameDiv: {
    columnGap: 20,
    display: 'flex',
    alignItems: 'center',
  },
  address: {
    display: 'flex',
    columnGap: 5,
    alignItems: 'center',
  },
  avatar: {
    height: 80,
    width: 80,
  },
});

export default AddPartnerCard;
